import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ROUTES } from '@/app/routes';
import { Spinner } from '@/components/ui';

export function PublicOnlyRoute() {
  const { user, isInitialized } = useAuth();
  if (!isInitialized) {
    return (
      <div className="flex min-h-[100dvh] items-center justify-center">
        <Spinner className="h-8 w-8 text-parchment-muted" />
      </div>
    );
  }
  if (user) {
    return <Navigate to={ROUTES.dashboard} replace />;
  }
  return <Outlet />;
}
